import * as table from './table/thunks'
import * as details from './details/thunks'

export default {
    table,
    details
}
